import { render, staticRenderFns } from "./GJEmpower.vue?vue&type=template&id=719b702e&scoped=true"
import script from "./GJEmpower.vue?vue&type=script&lang=js"
export * from "./GJEmpower.vue?vue&type=script&lang=js"
import style0 from "./GJEmpower.vue?vue&type=style&index=0&id=719b702e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719b702e",
  null
  
)

export default component.exports